import { render, staticRenderFns } from "./SubjectLink.vue?vue&type=template&id=05be9bb1&scoped=true&"
import script from "./SubjectLink.vue?vue&type=script&lang=js&"
export * from "./SubjectLink.vue?vue&type=script&lang=js&"
import style0 from "./SubjectLink.vue?vue&type=style&index=0&id=05be9bb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be9bb1",
  null
  
)

export default component.exports